import { render, staticRenderFns } from "./FooterTbf.vue?vue&type=template&id=2d23c7c5&"
import script from "./FooterTbf.vue?vue&type=script&lang=js&"
export * from "./FooterTbf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports